module.exports = __webpack_public_path__ + "img/download.9e3d2953.gif";